<script>
import DocumentViewer from '@/components/common/DocumentViewer.vue'
import Testletter from '@/components/testletter/Testletter.vue'
import TestletterForm from '@/components/testletter/TestletterForm.vue'
import TestletterCompleted from '@/components/testletter/TestletterCompleted.vue'

export default {
  components: {
    DocumentViewer,
    Testletter,
    TestletterForm,
    TestletterCompleted
  },
  data() {
    return {
      pdfData: '',
      pdfDataZoom: '',
      jwt: '',
      loadingPdfData: false,
      loadingPdfDataZoom: false,
      submittingTestletter: false,
      userData: {
        company: '',
        firstName: '',
        lastName: '',
        address: '',
        zipCode: '',
        city: '',
        email: '',
        newsletter: false,
        filled: false
      },
      testletterForm: true,
      documentViewer: false,
      completed: false
    }
  },
  created() {
    this.loadingPdfData = true
    this.$uploadService
      .getTestFile({ scaling: 1 })
      .then(response => {
        this.pdfData = response.image
      })
      .catch(() => {
        this.$notify(this.$t('component.testletter.load.failed.initial'), { type: 'error' })
      })
      .finally(() => {
        this.loadingPdfData = false
      })
  },
  methods: {
    getMappedFormData() {
      const { company, lastName, firstName, address, zipCode, city, email } =
        this.userData
      const mappedFormData = {
        firma: company,
        nachname: lastName,
        vorname: firstName,
        adresse: address,
        plz: zipCode,
        ort: city,
        eMail: email
      }
      return mappedFormData
    },
    async handleShowDocumentViewer() {
      this.loadingPdfDataZoom = true
      if (this.userData.filled) {
        this.$uploadService
          .putTestFile({ userData: this.getMappedFormData(), scaling: 3 })
          .then(response => {
            this.pdfDataZoom = response.image
          })
          .catch(() => {
            this.$notify(this.$t('notification.testletter.load.failed.zoom'), { type: 'error' })
          })
      } else {
        await this.$uploadService
          .getTestFile({ scaling: 3 })
          .then(response => {
            this.pdfDataZoom = response.image
          })
          .catch(() => {
            this.$notify(this.$t('notification.testletter.load.failed.zoom'), { type: 'error' })
          })
      }
      this.loadingPdfDataZoom = false
      this.documentViewer = true
    },
    handleFormSubmit() {
      this.loadingPdfData = true
      this.$uploadService
        .putTestFile({ userData: this.getMappedFormData(), scaling: 1 })
        .then(response => {
          this.pdfData = response.image
          this.jwt = response.jwt
          this.userData.filled = true
          this.testletterForm = false
        })
        .catch(() => {
          this.$notify(this.$t('notification.testletter.load.failed.submit.form'), { type: 'error' })
        })
        .finally(() => {
          this.loadingPdfData = false
        })
    },
    handleTestletterSubmit() {
      this.submittingTestletter = true
      this.$uploadService
        .postTestFile({
          userData: this.getMappedFormData(),
          jwt: this.jwt
        })
        .then(() => {
          this.completed = true
        })
        .catch(() => {
          this.$notify(this.$t('notification.testletter.load.failed.submit'), { type: 'error' })
        })
        .finally(() => {
          this.submittingTestletter = false
        })
    }
  }
}
</script>
<template>
  <v-container>
    <DocumentViewer
      :show="documentViewer"
      :pdf-data="pdfData"
      :pdf-data-zoom="pdfDataZoom"
      @onClose="documentViewer = false"
    />
    <TestletterForm
      v-model="userData"
      :show="testletterForm"
      :loading="loadingPdfData"
      @onClose="testletterForm = false"
      @onCancel="testletterForm = false"
      @onSubmit="handleFormSubmit"
    />
    <TestletterCompleted :show="completed" @onClose="completed = false" />
    <Testletter
      :user-data="userData"
      :pdf-data="pdfData"
      :loading="loadingPdfData"
      :loading-pdf-data-zoom="loadingPdfDataZoom"
      :submitting="submittingTestletter"
      @onShowForm="testletterForm = true"
      @onShowDocumentViewer="handleShowDocumentViewer"
      @onCompleted="handleTestletterSubmit"
    />
  </v-container>
</template>
